import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0CA23",
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m-2 15c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m4-5c0 .5-.5 1-1 1h-2c-.5 0-1-.5-1-1V6c0-.5.5-1 1-1h2c.5 0 1 .5 1 1z"
    }, null, -1)
  ]))]))
}
export default { render: render }